import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What Starting feels like",
  "description": "",
  "published": "2012-03-21T00:00:00.000Z",
  "redirect_from": ["/blog/what-starting-feels-like/swizec/4040"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "ebtGRvP3ILg",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Starting anything is `}<em parentName="p">{`scary`}</em>{`. Mindbogglingly scary in fact. But somebody's got to do it and if a 4th grader girl can lob herself off a big ski jump, you can stare down that text editor until it produces some code, a blogpost, a business plan or whatever.`}</p>
    <p>{`Certainly the best video I've seen this month :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      